// Quick contact log and timeline (task 1.9, D-038).
export const tenaxTimelineEnglishMessages = {
  tenax: {
    timeline: {
      title: "Timeline",
      empty: "Nothing yet.",
      log: "Log contact",
      log_title: "Log a contact",
      log_hint: "Tap the outcome: it is saved at once. The note is optional.",
      note: "Note (optional)",
      logged: "Contact logged",
      whatsapp: "WhatsApp",
      instagram: "Instagram",
      outcome: {
        sent: "Sent",
        replied: "Replied",
        no_reply: "No reply",
        positive: "Positive",
        negative: "Negative",
      },
      kind: {
        note: "Note",
        stage: "Stage",
        step: "Step done",
        email: "Email sent",
        order: "Order",
        order_request: "Order request",
      },
      stage_to: "%{deal} moved to %{stage}",
      step_done: "%{step} (%{task})",
    },
  },
};

export const tenaxTimelineItalianMessages = {
  tenax: {
    timeline: {
      title: "Timeline",
      empty: "Ancora niente.",
      log: "Registra contatto",
      log_title: "Registra un contatto",
      log_hint: "Tocca l'esito: si salva subito. La nota è facoltativa.",
      note: "Nota (facoltativa)",
      logged: "Contatto registrato",
      whatsapp: "WhatsApp",
      instagram: "Instagram",
      outcome: {
        sent: "Inviato",
        replied: "Risposto",
        no_reply: "Nessuna risposta",
        positive: "Positivo",
        negative: "Negativo",
      },
      kind: {
        note: "Nota",
        stage: "Fase",
        step: "Passaggio fatto",
        email: "Email inviata",
        order: "Ordine",
        order_request: "Richiesta d'ordine",
      },
      stage_to: "%{deal} passa a %{stage}",
      step_done: "%{step} (%{task})",
    },
  },
};
